import { Autocomplete, Box, createFilterOptions, InputAdornment, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { SearchBarContext } from '../contexts/SearchBarContext'
import SearchIcon from '@mui/icons-material/Search'
import { useForm } from 'react-hook-form'
import communityService from '../../services/communityService'
import { useSearchParams } from 'react-router-dom'

const AutoCompleteSearchBar = () => {
  const { communityId } = useContext(SearchBarContext)
  const defaultFilterOptions = createFilterOptions()
  const [communities, setCommunities] = useState()
  const placeholder = communityId ? 'Search in r/' + communityId : 'Search Redditlike'
  const [defaultValue, setDefaultValue] = useState([])
  const methods = useForm({ mode: 'onChange' })
  const { handleSubmit, setValue, formState: { errors } } = methods
  const [searchParams, setSearchParams] = useSearchParams()
  const keyword = methods.watch('keyword')
  const selectedCommunities = methods.watch('communities')

  useEffect(() => {
    selectedCommunities && searchParams.set('communities', selectedCommunities)
    keyword && searchParams.set('keyword', keyword)
  }, [selectedCommunities, keyword])

  useEffect(() => {
    if (communityId) {
      const defaultOption = communities?.find((community) => community.id === communityId)
      setDefaultValue([defaultOption])
    } else {
      setDefaultValue([])
    }
  }, [communityId])

  useEffect(() => {
    communityService.fetchCommunities()
      .then(res => setCommunities(res))
      .catch(err => console.log(err))
      // .finally(() => setLoading(false))
  }, [])

  const submitHandler = ({ communities, keyword }) => {
    setSearchParams(searchParams)
  }

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state).slice(0, 7)
  }

  const searchOnInputChangeHandler = (event, value, reason) => {
    console.log('onInputChangeHandler: ', value)
    setValue('keyword', value)
  }

  const onChangeHandler = (event, value, reason) => {
    console.log('onChangeHandler: ', value)
    setValue('communities', value.map(option => option.id))
    if (reason === 'reset') {
      setDefaultValue([])
    } else {
      setDefaultValue(value)
    }
  }

  return (
    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
      {communities
        ? (
          <form onSubmit={handleSubmit(submitHandler)}>
            <Autocomplete
              size="small"
              multiple
              filterSelectedOptions
              options={communities}
              filterOptions={filterOptions}
              value={defaultValue ?? []}
              isOptionEqualToValue={(options, value) => options?.id === value?.id}
              getOptionLabel={(option) => 'r/' + option?.id}
              onChange={onChangeHandler}
              onInputChange={searchOnInputChangeHandler}
              popupIcon={false}
              noOptionsText={false}
              limitTags = {1}
              sx={{
                width: 285,
                '& .MuiInputBase-input': {
                  // vertical padding + font size from searchIcon
                  fontSize: 14
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={placeholder}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <InputAdornment position="start" sx={{ mr: -0.5 }}>
                          <SearchIcon/>
                        </InputAdornment>
                        {params.InputProps.startAdornment}
                      </>
                    )
                  }}
                />
              )}
            />
          </form>
          )
        : (
          <></>
          )
      }
    </Box>
  )
}

export default AutoCompleteSearchBar
